import { useForm, Controller } from "react-hook-form";
import SecondarySkillRequestModel from "../../../../models/admin/skill/request/SecondarySkillRequestModel";
import { OBJECT_NAME_RULE_SECONDARY_SKILL, OBJECT_DESCRIPTION_RULE, FORM_SELECT_RULE } from "../../../../utils/validation-utils";
import IdNameModel from "../../../../models/common/IdNameModel";
import toasterUtils from "../../../../utils/toaster-utils";
import { Button, FormControl, TextField, Autocomplete } from "@mui/material";

interface SecondarySkillProps {
    objSecondarySkill: SecondarySkillRequestModel;
    primarySkillList: IdNameModel[];
    actionType: string;
    onCloseSecondarySkill: () => void;
    onSecondarySkillSave: (objSecondarySkill: SecondarySkillRequestModel) => void;
}

const SecondarySkillCreateComponent = (props: SecondarySkillProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<SecondarySkillRequestModel>({
        mode: "onChange",
        defaultValues: props.objSecondarySkill
    });

    const onSubmit = (formData: SecondarySkillRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onSecondarySkillSave(formData);
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="primarySkillId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.primarySkillList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.primarySkillList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Primary Skill" size="small" required margin="normal" fullWidth error={!!errors.primarySkillId} helperText={errors.primarySkillId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.secondarySkillName}>
                                <TextField label="Secondary Skill Name" size="small"
                                    {...register("secondarySkillName", OBJECT_NAME_RULE_SECONDARY_SKILL)} error={!!errors.secondarySkillName} helperText={errors.secondarySkillName?.message} placeholder="Secondary Skill" autoComplete="off" required />
                            </FormControl>
                        </div>
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.description}>
                                <TextField label="Description" size="small" multiline rows={3}
                                    {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} placeholder="Description" autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseSecondarySkill}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default SecondarySkillCreateComponent;